<template>
  <b-table :items="items" :fields="fields" responsive show-empty bordered small class="mb-0">
    <template #cell(legs)="row">
      <div class="font-weight-bold text-center">{{ row.item.legs }}</div>
    </template>

    <template #cell(stakeMin)="row">
      <b-form-input v-model="row.item.stakeMin" size="sm" type="number" />
    </template>

    <template #cell(stakeMax)="row">
      <b-form-input v-model="row.item.stakeMax" size="sm" :disabled="row.item.stakeMax === '∞'" />
    </template>

    <template #cell(oddsMin)="row">
      <b-form-input v-model="row.item.oddsMin" size="sm" type="number" />
    </template>

    <template #cell(oddsMax)="row">
      <b-form-input v-model="row.item.oddsMax" size="sm" :disabled="row.item.oddsMax === '∞'" />
    </template>

    <template #cell(maxLiability)="row">
      <b-input-group size="sm">
        <b-input-group-prepend is-text>$</b-input-group-prepend>
        <b-form-input v-model="row.item.maxLiability" type="number" />
      </b-input-group>
    </template>

    <template #cell(status)="row">
      <div class="d-flex justify-content-center">
        <b-form-checkbox v-model="row.item.status" switch />
      </div>
    </template>

    <template #cell(actions)="row">
      <div class="d-flex justify-content-center" v-if="row.item.id">
        <b-button variant="flat-secondary" size="sm" class="btn-icon p-0 mr-1" @click="$emit('edit', row.index)">
          <feather-icon icon="EditIcon" />
        </b-button>
        <b-button variant="flat-danger" size="sm" class="btn-icon p-0" @click="$emit('delete', row.index)">
          <feather-icon icon="Trash2Icon" />
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import {
  BTable,
  BFormInput,
  BFormCheckbox,
  BButton,
  BInputGroup,
  BInputGroupPrepend
} from "bootstrap-vue";

export default {
  name: "RulesTable",
  components: {
    BTable,
    BFormInput,
    BFormCheckbox,
    BButton,
    BInputGroup,
    BInputGroupPrepend
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fields: [
        { key: 'legs', label: 'Legs', thClass: 'text-center' },
        { key: 'stakeMin', label: 'Stake Min' },
        { key: 'stakeMax', label: 'Stake Max' },
        { key: 'oddsMin', label: 'Odds Min' },
        { key: 'oddsMax', label: 'Odds Max' },
        { key: 'maxLiability', label: 'Max Liability' },
        { key: 'status', label: 'Status', thClass: 'text-center' },
        { key: 'actions', label: 'Actions', thClass: 'text-center' }
      ]
    };
  }
};
</script>
